import styled from '@emotion/styled';

const S = {};

S.Benefits = styled.ul`
  display: grid;
  grid-gap: 1rem;
  text-align: initial;
`;

export default S;
